import "@Styles/Shared/MyAccount/Templates/InterstitialAnonymousCta/interstitialAnonymousCta_sm.less";
import "@Styles/Shared/MyAccount/BC/interstitialAnonymousCta_sm.less";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import signup from '../NewsletterSignup/anonymousNewsletterSignup';
import { getRegUrlWithEmailParam, raiseNewsletterAnalyticsEvent } from '../_util';
import { ANALYTICS_INTERSTITIAL_VIEW_EVENT, ANALYTICS_INTERSTITIAL_CLOSE_EVENT } from '../_constants';
import modal from '@Shared/Common/Scripts/Components/modalBase';
import { cookie } from '@Shared/Common';
export default {
  props: {
    config: {
      type: Object
    }
  },
  data: function data() {
    return {
      settings: this.config ? this.config.settings : {},
      newsletters: this.config ? this.config.unsubscribedNewsletters : {},
      interstitialSettings: this.config && this.config.settings ? this.config.settings.interstitialSettings : {},
      isSubscribed: false,
      regUrl: '',
      isVisible: false,
      styleOverrides: {}
    };
  },
  components: {
    'signup': signup,
    'modal': modal
  },
  mounted: function mounted() {
    this.$_mounted();
    this.$_setBackgroundImage(this.settings.interstitialBackgroundImageUrl);
  },
  methods: {
    show: function show() {
      this.isVisible = true;
      this.$_setInterstitialShownCookie();
      var newsletter = this.newsletters && this.newsletters.length > 0 ? this.newsletters[0] : null;
      raiseNewsletterAnalyticsEvent(ANALYTICS_INTERSTITIAL_VIEW_EVENT, newsletter, this.settings.location);
    },
    close: function close() {
      this.isVisible = false;
      var newsletter = this.newsletters && this.newsletters.length > 0 ? this.newsletters[0] : null;
      raiseNewsletterAnalyticsEvent(ANALYTICS_INTERSTITIAL_CLOSE_EVENT, newsletter, this.settings.location);
    },
    focusStart: function focusStart() {
      this.$refs.anonymousSignup && this.$refs.anonymousSignup.focusSignup();
    },
    showThankYou: function showThankYou(data) {
      this.isSubscribed = true;
      this.regUrl = getRegUrlWithEmailParam(this.settings.registrationUrl, data.email);
    },
    $_setInterstitialShownCookie: function $_setInterstitialShownCookie() {
      var cookieName = "HideInterstitial";
      cookie.setCookie(cookieName, true, this.interstitialSettings.interstitialShownCookieExpiry);
    },
    $_getEl: function $_getEl() {
      /* istanbul ignore next */
      return this.$el;
    },
    $_mounted: function $_mounted() {
      var self = this;

      if (GeneralMills.PandoSites.NewsletterCta.Interstitial.UseDefaultImplementation == false) {
        GeneralMills.PandoSites.NewsletterCta.Interstitial.Show = self.show;
        self.$_getEl().dispatchEvent(new CustomEvent("newslettercta-interstitial-mounted", {
          bubbles: true
        }));
      } else {
        var pageHopCookieValue = cookie.getCookie("PageCount");
        var numberOfPageHops = pageHopCookieValue ? parseInt(pageHopCookieValue) : 0; //Show the interstitial if -
        //1.the user has not already seen it,
        //2.no of page hops is greather than or equal to the set count,
        //3.the location is US
        //4.if the user is not interacting with the searchbox or hints
        //5.if the user is not interacting with the CGC form modal

        if (!cookie.getCookie("HideInterstitial") && numberOfPageHops >= self.interstitialSettings.interstitialPopUpPageHops && cookie.getCookie("gmi.location") == "US") setTimeout(function () {
          var searchHintsContainer = document.querySelector(".searchHintContainer");
          var isUserInteractingWithCgc = document.querySelector(".formModal") !== null;
          if (searchHintsContainer.children.length <= 0 && !isUserInteractingWithCgc) self.show();
        }, self.interstitialSettings.interstitialPopUpTimeDelay);
      }
    },
    $_setBackgroundImage: function $_setBackgroundImage(imgUrl) {
      if (imgUrl) {
        this.$set(this.styleOverrides, 'backgroundImage', "url('" + imgUrl + "')");
      } else {
        this.$delete(this.styleOverrides, 'backgroundImage');
      }
    }
  }
};